var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c(_vm.isLink ? 'nuxt-link' : 'span',{tag:"component",staticClass:"flex",attrs:{"to":{ name: 'vendors-settings-subscription' }}},[(_vm.SUBSCRIPTION_PLAN_IDS.FREE !== _vm.id)?_c('img',{staticClass:"img",attrs:{"src":_vm.badgeSrc,"width":"100","height":"24"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }